var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Test")]),_c('button',{on:{"click":_vm.testApi}},[_vm._v("Test Api")])])
}
var staticRenderFns = []

export { render, staticRenderFns }